import { Button } from '@/components/ui/button'
import { Heading } from '@/components/ui/heading'
import * as Menu from '@/components/ui/menu'
import { useAuth } from '@stateApp'
import { Index } from 'solid-js'
import { useService } from 'solid-services'
import { Box, Flex, HStack } from 'styled-system/jsx'
import { ListTypes, useList } from '../state'
import { pill } from './pillStyles'

const Display = (props: { option: ListTypes }) => {
  return props.option
}

export default function ListSelector() {
  const { listType, setListType } = useService(useList)()
  const { isAdmin } = useService(useAuth)()

  const activeOptions = () => {
    const options = Object.values(ListTypes)

    if (isAdmin()) {
      // options.push(ListTypes.inactive)
    }

    return options
  }

  return (
    <>
      <Flex
        role="group"
        aria-label="Filter setups"
        gap='6px'
        alignItems="center"
        display={{
          base: 'flex',
          mdDown: 'none',
        }}
      >
        <Index each={activeOptions()}>
          {(option) => (
            <button
              type="button"
              aria-pressed={listType() === option()}
              class={pill(listType() === option())}
              onClick={() => setListType(option())}
            >
              {option()}
            </button>
          )}
        </Index>
      </Flex>
      <Box
        display={{
          base: 'none',
          mdDown: 'block',
        }}
      >
        <Menu.Root onSelect={({ value }) => setListType(value as ListTypes)}>
          <Menu.Trigger>
            <Button
              variant="outline"
              size="xs"
            >
              <Heading textTransform="capitalize">
                {listType() === ListTypes.published ? 'Published' : `My ${listType()}`}
              </Heading>
            </Button>
          </Menu.Trigger>
          {/* <Portal> */}
          <Menu.Positioner>
            <Menu.Content>
              <Menu.ItemGroup>
                <Index each={activeOptions()}>
                  {(option) => (
                    <Menu.Item value={option()}>
                      <HStack gap={2}>
                        <Heading textTransform="capitalize">
                          <Display option={option()} />
                        </Heading>
                      </HStack>
                    </Menu.Item>
                  )}
                </Index>
              </Menu.ItemGroup>
            </Menu.Content>
          </Menu.Positioner>
          {/* </Portal> */}
        </Menu.Root>
      </Box>
    </>
  )
}
